import { TempleDashboardResponse } from 'pages/dashboard/Temple/Analytics/types';
import { TempleAnalyticsActionTypes } from './constants';

type State = {
    dashboardData: TempleDashboardResponse | null;
    loading: boolean;
    error?: string;
};

const INIT_STATE: State = {
    dashboardData: null,
    loading: false,
};

type TempleAnalyticsActionType = {
    type:
        | TempleAnalyticsActionTypes.API_RESPONSE_SUCCESS
        | TempleAnalyticsActionTypes.API_RESPONSE_ERROR
        | TempleAnalyticsActionTypes.GET_TEMPLE_DASHBOARD
        | TempleAnalyticsActionTypes.RESET;

    payload: {
        actionType?: string;
        data?: any;
        error?: string;
    };
};

const TempleAnalytics = (
    state: State = INIT_STATE,
    action: TempleAnalyticsActionType
) => {
    switch (action.type) {
        case TempleAnalyticsActionTypes.API_RESPONSE_SUCCESS: {
            const { actionType, data } = action.payload;

            switch (actionType) {
                case TempleAnalyticsActionTypes.GET_TEMPLE_DASHBOARD:
                    return {
                        ...state,
                        dashboardData: data,
                        loading: false,
                        error: undefined,
                    };

                default:
                    return state;
            }
        }

        case TempleAnalyticsActionTypes.API_RESPONSE_ERROR: {
            const { actionType, error } = action.payload;

            switch (actionType) {
                case TempleAnalyticsActionTypes.GET_TEMPLE_DASHBOARD:
                    return {
                        ...state,
                        loading: false,
                        error,
                    };

                default:
                    return state;
            }
        }

        case TempleAnalyticsActionTypes.GET_TEMPLE_DASHBOARD:
            return {
                ...state,
                loading: true,
            };

        case TempleAnalyticsActionTypes.RESET:
            return INIT_STATE;

        default:
            return state;
    }
};

export default TempleAnalytics;